// extracted by mini-css-extract-plugin
export default {"body":"_3_LOMULcmNKyVx02sGY2uQ"};